const tools = [
  {
    name: "Admin",
    icon: "admin",
    subs: [
      { name: "Manage Contacts", link: "contacts-listing" },
      { name: "Manage Members", link: "members-listing" },
      { name: "Manage Manufacturers", link: "manufacturers" },
      { name: "Manage Ethics Records", link: "admin-ethics-records" },
      { name: "Manage Document Library", link: "admin-library" },
      { name: "Member Mailer", link: "member-mailer" },
    ],
    show: true,
  },
  {
    name: "Trading Network",
    icon: "waypoints",
    subs: [
      { name: "Trading Network Tools", link: "trading-network" },
      { name: "PowerSearch for Equipment", link: "search" },
      { name: "Edit Searches", link: "searches" },
      { name: "Manage your Listing", link: "manage" },
      {
        name: "Broadcast-Add Listings in Fixed Format",
        link: "add-listing",
      },
      {
        name: "PowerCast-Add Listings in Free Format",
        link: "broadcast-email",
      },
      {
        name: "PowerLoad-Listings in a Spreadsheet",
        link: "upload",
      },
    ],
    show: true,
  },
  {
    name: "Settings",
    icon: "contacts",
    subs: [
      {
        name: "Your Profile",
        link: "edit-contact",
        params: true,
      },
      {
        name: "Company Profile",
        link: "settings",
      },
    ],
    show: true,
  },
  {
    name: "Subscriber / Member Search",
    icon: "search",
    link: "member-directory",
    subs: [],
    show: true,
  },
  {
    name: "Equipment Specifications",
    icon: "wrench",
    link: "equip-spec-sheets",
    subs: [],
    show: true,
  },
  {
    name: "Tips and Resources",
    icon: "tips",
    subs: [
      { name: "Solution Showcase", link: "ask-the-pros" },
      { name: "Member Document Library", link: "member-library" },
    ],
    show: true,
  },
  {
    name: "Ethics and Compliance",
    icon: "ethics",
    link: "ethics-records",
    subs: [],
    show: true,
  },
  {
    name: "Manufacturer Information",
    icon: "other",
    subs: [
      { name: "CISCO Information", link: "cisco-members" },
      { name: "IBM Information", link: "imb-information" },
    ],
    show: true,
  },
];

export default tools;
